import React from 'react';

import './tournamentItem.scss';

interface Props {
    title: string | React.ReactNode;
    count?: number;
    children?: JSX.Element;
}

const TournamentItem: React.FC<Props> = ({ title, count, children = null }) => (
    <React.Fragment>
        {children}

        <div styleName="container">
            <div styleName="title">{title}</div>
            {count && <div styleName="counter">{count}</div>}
        </div>
    </React.Fragment>
);

export default React.memo(TournamentItem);
